import { Injectable } from '@angular/core';
import { IFinalFieldTestXmlExportResult } from '@reporting/interfaces/exports/final-field-test-xml-export-result';
import { INotPlantedXmlExportResult } from '@reporting/interfaces/exports/not-planted-xml-export-result';
import { IPlantingXmlExportResult } from '@reporting/interfaces/exports/planting-xml-export-result';
import { IVolunteerXmlExportResult } from '@reporting/interfaces/exports/volunteer-xml-export-result';
import { INotPlantedReportExportRequest, IPlantingReportExportRequest, IVolunteerReportExportRequest } from '@reporting/interfaces';
import { Observable } from 'rxjs';
import { environment } from '@app/environment';
import { Http } from '@core/http/http';
import { IFinalFieldTestReportExportRequest } from '../interfaces/final-field-test-report';

@Injectable({
    providedIn: 'root'
})
export class XmlService {

    constructor(private http: Http) { }

    public ExportToXmlPlantingReport(request: IPlantingReportExportRequest): Observable<IPlantingXmlExportResult> {
        console.log(`${environment.apiRoot}api/v1/XmlExport/PlantingReport`);
        return this.http.post(`${environment.apiRoot}api/v1/XmlExport/PlantingReport`, request);
    }

    public ExportToXmlNotPlantedReport(request: INotPlantedReportExportRequest): Observable<INotPlantedXmlExportResult> {
        return this.http.post(`${environment.apiRoot}api/v1/XmlExport/NotPlantedReport`, request);
    }

    public ExportToXmlVolunteerReport(request: IVolunteerReportExportRequest): Observable<IVolunteerXmlExportResult> {
        return this.http.post(`${environment.apiRoot}api/v1/XmlExport/VolunteerReport`, request);
    }

    public ExportToXmlFinalFieldTestReport(request: IFinalFieldTestReportExportRequest): Observable<IFinalFieldTestXmlExportResult> {
        return this.http.post(`${environment.apiRoot}api/v1/XmlExport/FinalFieldTestReport`, request);
    }
}
